import React from 'react';
import classes from './style.module.css';

const Select = ({
    register,
    name,
    label,
    items,
    defaultLabel,
    isDisabled
}) => {

    return (
        <label
            htmlFor={name}
            className={classes.label}
        >
            <span className={classes.label__helper}>
                {label}
            </span>
            <select
                {...register(name)}
                id={name}
                className={classes.label__field}
                disabled={isDisabled}
            >
                <option value="" style={{ display: 'none' }}>{defaultLabel}</option>
                {
                    items.map((item) => (
                        <option value={item.value}>{item.label}</option>
                    ))
                }
            </select>
        </label>
    )
}

export default Select;